module.exports = __webpack_public_path__ + "img/midrank.c6b5590c.png";